export default "__VITE_ASSET__qCRg6h$B__"